export default "__VITE_PUBLIC_ASSET__32f15052__"